import styled from "styled-components";

import { colorsPalettes, mixins } from "@similarweb/styles";

import ExportInfoMessage from "../../../table-actions-panel/components/ExportInfoMessage/ExportInfoMessage";
import PanelSubmitButton from "../../../table-actions-panel/components/PanelSubmitButton/PanelSubmitButton";
import SelectionDropdownView from "../../../table-actions-panel/components/SelectionDropdown/SelectionDropdown";

export const StyledTitle = styled.span`
    ${mixins.setFontVariant("button", colorsPalettes.carbon["0"])};
    user-select: none;
`;

export const StyledSelectionDropdown = styled(SelectionDropdownView)`
    margin-left: 20px;
`;

export const StyledSubmitButton = styled(PanelSubmitButton)`
    margin-left: 20px;
`;

export const StyledInfoMessage = styled(ExportInfoMessage)`
    margin-left: 16px;
`;
